import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { useRoomRates } from '@features/rates';

import { toRates, toRoomAvailabilityParams } from './mappers';

export default function useRates(
  roomId: string,
  journeyParams: ParsedJourneyParams,
  language?: string
) {
  const roomAvailabilityParams = toRoomAvailabilityParams(journeyParams);
  const {
    rates: roomRates,
    isFetching,
    promoRateCodeIssue,
  } = useRoomRates(roomId, roomAvailabilityParams, language);

  const rates = toRates(roomRates);

  const lowestRate = rates
    .map(({ pricePerStay }) => pricePerStay)
    .sort((a, b) => (b?.amount ?? 0) - (a?.amount ?? 0))
    .pop();

  return {
    rates,
    lowestRate: lowestRate ?? null,
    isFetching,
    promoRateCodeIssue,
  };
}
